import React, { useState, useEffect, useRef } from "react";
import api from "../../../config/axiosConfig";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';

function BookingCalendar() {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [data, setData] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [residentials, setResidentials] = useState([]);
  const tableRef = useRef(null);
  const [calendarData, setCalendarData] = useState([]);
  const bookingColors = {};
  const colors = ['#90e0ef', '#ffc8dd', '#caffbf', '#ffd6a5', '#bdb2ff']; // Add more as needed
  let colorIndex = 0;
  
  // Fetch data
  const getData = async () => {
    try {
      const bookingResponse = await api.get("/residential/bookings");
      setData(bookingResponse.data);

      const seasonResponse = await api.get("/seasons");
      setSeasons(seasonResponse.data);

      const residentialResponse = await api.get("/residential");
      setResidentials(residentialResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // Generate calendar data
  // Generate calendar data
  const generateYearCalendar = (year) => {
    const calendarData = [];

    for (let month = 0; month < 12; month++) {
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day);
        const formattedDate = date.toISOString().split("T")[0]; // YYYY-MM-DD format

        // Check season
        const currentSeason = seasons.find(
          (season) =>
            formattedDate >= season.startDate.split("T")[0] &&
            formattedDate <= season.endDate.split("T")[0]
        );

        // Filter bookings for the current date
        const bookingsForDate = data.filter(
          (booking) => booking.date && booking.date.split("T")[0] === formattedDate
        );

        // Map bookings to residences
        const residences = residentials.reduce((acc, residential) => {
          const bookingForResidence = bookingsForDate.find((b) => b.residenceId === residential.id);

          acc[residential.name] = bookingForResidence
            ? {
              ...bookingForResidence,
              perDaypriceINR: bookingForResidence.perDaypriceINR,
            }
            : null;

          return acc;
        }, {});

        calendarData.push({
          date: date.getDate(),
          day: date.toLocaleDateString("en-US", { weekday: "short" }),
          month: date.toLocaleDateString("en-US", { month: "short" }),
          monthIndex: month,
          season: currentSeason ? currentSeason.name : "Off-season",
          residences,
        });
      }
    }
    return calendarData;
  };


  useEffect(() => {
    if (data.length > 0 && seasons.length > 0 && residentials.length > 0) {
      setCalendarData(generateYearCalendar(selectedYear));
    }
  }, [data, seasons, residentials, selectedYear]);

  // Scroll to the selected month
  useEffect(() => {
    if (tableRef.current) {
      const rows = tableRef.current.querySelectorAll("tbody tr");
      const firstRowOfMonth = Array.from(rows).find(
        (row) => row.dataset.monthIndex == selectedMonth
      );
      if (firstRowOfMonth) {
        const headerHeight = tableRef.current.querySelector("thead").offsetHeight || 0; // Calculate header height
        const scrollOffset = firstRowOfMonth.offsetTop - headerHeight; // Adjust for header height
        tableRef.current.scrollTo({
          top: scrollOffset,
          behavior: "smooth",
        });
      }
    }
  }, [calendarData, selectedMonth]);

  const getColorForBooking = (bookingId, bookingstatus) => {
    if (!bookingId) return '';
    // If inactive, return grey color
    if (bookingstatus === 0 || bookingstatus === false || bookingstatus === '0' || bookingstatus === 'No') {
      console.log("bookingstatus", bookingId,bookingstatus)
      
      return '#ccc'; // Or any shade of grey you like
    }
  
    // Assign and return color for active bookings
    if (!bookingColors[bookingId]) {
      bookingColors[bookingId] = colors[colorIndex % colors.length];
      colorIndex++;
    }
  
    return bookingColors[bookingId];
  };

  return (
    <Container fluid>
      <Row className="mb-4 mx-1">
        <h5>Booking Calendar</h5>
        <Col sm={6}>
          <div className="d-flex align-items-center">
            <Form.Label className="me-2">Select Year : </Form.Label>
            <InputGroup style={{ width: "250px" }}>
              <Form.Select
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
              >
                {[...Array(20)].map((_, index) => {
                  const year = new Date().getFullYear() - 5 + index;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Form.Select>
            </InputGroup>
          </div>
        </Col>
        <Col sm={6}>
          <div className="d-flex align-items-center">
            <Form.Label className="me-2">Select Month : </Form.Label>
            <InputGroup style={{ width: "250px" }}>
              <Form.Select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
                className="form-select"
                id="floatingSelect"
                aria-label="Floating label select example"
              >
                {Array.from({ length: 12 }, (_, index) => (
                  <option key={index} value={index}>
                    {new Date(0, index).toLocaleDateString("en-US", { month: "long" })}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </div>
        </Col>
      </Row>


      {/* Calendar Table */}
      <Row style={{ height: "78vh", overflowY: "auto", position: "relative", border: "1px solid #f1f1f1f1" }} className="mt-2 mx-1" ref={tableRef}>
        <Table striped bordered hover>
          <thead style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
            <tr>
              <th style={{ fontSize: '14px' }} >Month</th>
              <th style={{ fontSize: '14px' }} >Date</th>
              <th style={{ fontSize: '14px' }} >Day</th>
              <th style={{ fontSize: '14px' }} >Season</th>
              {residentials.map((row) => (
                <th key={row.id} style={{ color: row.residentialTypeId === 6 || row.residentialTypeId === 2 || row.residentialTypeId === 4 ? "blue" : "black", fontSize: '14px' }}>{row.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {calendarData.map((row, index) => (
              <tr key={index} data-month-index={row.monthIndex}>
                <td style={{ fontSize: "12px" }}>{row.month}</td>
                <td style={{ fontSize: "12px" }}>{row.date}</td>
                <td style={{ fontSize: "12px" }}>{row.day}</td>
                <td style={{ fontSize: "12px" }}>{row.season}</td>
                {residentials.map((residential) => {
                  const residenceDetails = row.residences[residential.name];

                  if (!residenceDetails) {
                    return <td key={residential.id} style={{ fontSize: "12px" }}>{residential.total ? residential.total.toLocaleString("en-IN") : ''}</td>; // No booking for this day
                  }

                  return (
                    <td key={residential.id} style={{ backgroundColor: getColorForBooking(residenceDetails.bookingId, residenceDetails.bookingstatus), fontSize: "12px" }}>
                      <span> <b>{residenceDetails.accountName}</b></span><br/>
                      <span>₹{residenceDetails.total.toLocaleString("en-IN")}</span><span className="m-2">{residenceDetails.discount > 0 ? 'Discount': ''}</span>
                    </td>
                  );
                })}

              </tr>
            ))}
          </tbody>

        </Table>
      </Row>
    </Container>
  );
}

export default BookingCalendar;
